/**
 * Minimal Empty Section Detector
 * Lightweight script that runs on all pages to detect and hide empty produkte-content sections
 * Only loads heavy assets when sections have actual content
 */

(function() {
  'use strict';
  
  // Prevent multiple executions
  if (window.emptySectionDetectorLoaded) return;
  window.emptySectionDetectorLoaded = true;

  function hideEmptySection(section) {
    // Minimal hiding with just essential styles
    section.style.display = 'none';
    section.style.visibility = 'hidden';
    section.style.height = '0';
    section.style.overflow = 'hidden';
    section.setAttribute('data-empty-section', 'true');
    
    // Replace content with minimal comment
    section.innerHTML = '<!-- Empty section hidden -->';
    
    console.log('Hidden empty section:', section.id);
  }

  function detectEmptySections() {
    // Find all produkte-content sections that don't have the content wrapper
    const allSections = document.querySelectorAll('[id*="produkte_content"]');
    
    allSections.forEach(section => {
      // If section doesn't have the main content wrapper, it's empty
      const hasContentWrapper = section.querySelector('.produkte-content');
      if (!hasContentWrapper) {
        hideEmptySection(section);
      }
    });
  }

  // Run detection when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectEmptySections);
  } else {
    detectEmptySections();
  }

  // Theme editor integration
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      setTimeout(detectEmptySections, 50);
    });
  }
})();
